import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
// src/components/Refresh.tsx
const RefreshIcon = ZepIcon((props) => /* @__PURE__ */ jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ jsx("g", {
		clipPath: "url(#clip0_1_3748)",
		children: /* @__PURE__ */ jsx("path", {
			d: "M17.468 3.74a1 1 0 0 1 1.225.707l1.098 4.098a1 1 0 0 1-.707 1.225l-4.098 1.098a1 1 0 1 1-.518-1.932l1.767-.473-1.374-.793c-3.072-1.774-7.105-.693-8.879 2.38-1.774 3.071-.693 7.104 2.38 8.878 3.072 1.774 7.104.694 8.878-2.379a1 1 0 0 1 1.732 1c-2.326 4.03-7.582 5.438-11.61 3.111-4.03-2.326-5.438-7.582-3.112-11.61 2.326-4.03 7.582-5.438 11.611-3.112l1.373.793-.473-1.766a1 1 0 0 1 .707-1.225Z",
			fill: props.fill || "currentColor"
		})
	}), /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", {
		id: "clip0_1_3748",
		children: /* @__PURE__ */ jsx("path", {
			fill: props.fill || "currentColor",
			d: "M0 0h24v24H0z"
		})
	}) })]
}));
export { RefreshIcon };
